import Reflux from 'reflux';

export default  Reflux.createActions([
  'show',
  'hide'
]);



// WEBPACK FOOTER //
// ./frontend/react/actions/modal.js